module.exports = __webpack_public_path__ + "e91d32f27dd13f60be7b163830839234.svg";